import cx from 'classnames';
import { string, func, bool } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import * as styles from './NoItemsCTA.module.scss';

const NoItemsCTA = (props) => {
  const { title, desc, ctaLabel, onClick, isMobile } = props;

  return (
    <div
      className={cx(styles.container, {
        [styles.mobile]: isMobile,
      })}
    >
      <i className={styles.icon} />
      <h3 className={styles.title}>{title}</h3>
      <p>{desc}</p>
      <Button className={styles.cta} onClick={onClick}>
        {ctaLabel}
      </Button>
      <br />
    </div>
  );
};

NoItemsCTA.propTypes = {
  title: string.isRequired,
  desc: string.isRequired,
  ctaLabel: string.isRequired,
  onClick: func.isRequired,
  isMobile: bool.isRequired,
};

export default NoItemsCTA;
